View = require 'view'
_ = require 'underscore'
template = require 'views/templates/search_help_popover'

module.exports = class SearchHelpView extends View
  viewTitleKey: 'help'

  render: ->
    @$el.html(template())

    @



// WEBPACK FOOTER //
// ./app/scripts/views/archive/search-help-view.coffee